import React, { useState } from "react";
import { QRCode } from 'react-qrcode-logo';
import ReactLoading from 'react-loading';

function QRCodeWithLoading({ text, size_=300 }) {
  console.log('text',text)
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <QRCode
        value={text}
        ecLevel="H"
        size={size_}
        logoImage="/images/trading/bitcoin.png"
        // logoWidth={50}
      />
    </div>
  );
}

export default QRCodeWithLoading;
